export const PING_USER_GUIDE_LINK =
  "https://help.pingintel.com/ping-maps-user-guide-v2";

export const SPEED_UNITS = {
  MPH: "mph",
  KPH: "kph",
} as const;
export type SpeedUnit = (typeof SPEED_UNITS)[keyof typeof SPEED_UNITS];

export const MINIMUM_ZOOM_REQUIRED_FOR_SELECTOR = 12;

export const PAGE_STATES = {
  MAP: "map",
  SUMMARY: "summary",
  POLICY_TERMS: "policy-terms",
} as const;
export type PageState = (typeof PAGE_STATES)[keyof typeof PAGE_STATES];
